<template>
  <Card>
    <h3>Number of facts by events</h3>
    <p>
      This table shows how many facts are associated to all the disaster facts
      whose start date is between Jan 1st and Dec 31st. Only events for which
      the value is not 1 are displayed.
    </p>
    <ag-grid-vue
      style="width: 100%; height: 420px;"
      class="ag-theme-material"
      :gridOptions="gridOptions"
      :columnDefs="columnDefs"
      :rowData="tableData"
    ></ag-grid-vue>
  </Card>
</template>

<script>
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";

export default {
  components: { AgGridVue },
  data() {
    return {
      tableData: [],
      gridOptions: {
        defaultColDef: {
          sortable: true,
          resizable: true,
        },
        enableRangeSelection: true,
        allowContextMenuWithControlKey: true,
        onFirstDataRendered: params => {
          params.api.sizeColumnsToFit();
        },
        getContextMenuItems: params => [
          {
            name: "Go to Event",
            action: () => {
              const id = params.node.data.event_id;
              this.$router.push(`/events/${id}`);
            },
          },
          "separator",
          ...params.defaultItems,
        ],
      },
      columnDefs: Object.freeze([
        {
          headerName: "ID",
          width: 40,
          field: "event_id",
        },
        {
          headerName: "Name",
          field: "event_name",
        },
        {
          headerName: "Start Date",
          width: 40,
          field: "start_date",
          sortable: true,
        },
        {
          headerName: "Country",
          width: 60,
          field: "idmc_short_name",
          enableRowGroup: true,
        },
        {
          headerName: "Facts",
          width: 40,
          field: "nfacts",
        },
      ]),
    };
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      let response = await axios.get("/psql/qa_dashboard_grid_facts_by_events");
      this.tableData = response.data;
    },
  },
};
</script>
